import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { openAppPromoDialog } from "../components/AppPromoDialog";

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Grid component="footer" className="smPoolFooter" container>
            <Grid className="smPoolFooterInner" container>
                <Grid item xs={12} lg={4} className="smPoolFooterBrand">
                    <img src="/logo.png" alt="SignaMining.de Logo" />
                    <div>
                        <Typography component="strong">SignaMining.de</Typography>
                        <Typography component="small">Signum Mining Deutschland</Typography>
                    </div>
                </Grid>

                <Grid item xs={12} lg={8} className="smPoolFooterHero">
                    <img src="/banner.png" alt="SignaMining.de Varga-Tech Banner" />
                </Grid>
            </Grid>

            <Grid className="smPoolFooterContent" container>
                <Grid item xs={12} lg={8} className="smPoolFooterSeo">
                    <Typography component="p" className="smFooterEyebrow">Signum Mining Pool · HDD-/SSD-Mining · Live Pool-Daten</Typography>
                    <Typography component="h2">
                        Varga-Tech SIGNUM Pool – moderner Signum Mining Pool für HDD-/SSD-Mining in Deutschland.
                    </Typography>
                    <Typography component="p">
                        Der Pool zeigt Live-Daten zu Kapazität, aktiven Minern, Blockhöhe, Netzwerkgröße, Deadlines und Rewards. SignaMining.de ergänzt diese Oberfläche mit verständlichen Erklärungen zu SIGNA, Proof of Capacity Plus, Wallet, Plotten, Miner-Setup, Pool-Mining, Auszahlung und rechtlichen Informationen.
                    </Typography>
                </Grid>

                <Grid item xs={12} lg={4} className="smPoolFooterLinks">
                    <Button component="a" href="https://signamining.de" target="_blank" rel="noopener">Mehr Infos</Button>
                    <Button component="a" href="https://signamining.de/?page=mining" target="_blank" rel="noopener">Mining erklärt</Button>
                    <Button onClick={openAppPromoDialog} startIcon={<PhoneIphoneIcon />}>Android / iPhone App</Button>
                    <Button component="a" href="https://signamining.de/?page=impressum" target="_blank" rel="noopener">Impressum</Button>
                    <Button component="a" href="https://signamining.de/?page=datenschutz" target="_blank" rel="noopener">Datenschutz</Button>
                </Grid>
            </Grid>

            <Grid className="smPoolFooterBottom" item xs={12}>
                <Typography component="small">© {currentYear} SignaMining.de · Keine Finanzberatung · Kryptowährungen und Mining-Erträge sind mit Risiken verbunden.</Typography>
            </Grid>
        </Grid>
    );
};
